module.exports = "/_next/static/images/92da3352a88cdc359367a9e4d4035c06-nubanker-pm@2x.jpg";